import { useContext } from 'react'
import { PlatformContext } from '@/contexts/ProtocolContext/ProtocolContext'

export function usePlatform() {
    const context = useContext(PlatformContext)
    if (!context) {
        throw new Error('usePlatform must be used within a PlatformProvider')
    }
    return context
}
